import { Injectable } from '@angular/core';
import { BaseCrudService } from '../../../core/data/services/base-crud.service';
import Claim from '../../../core/data/models/claim.model';
import ClaimGlassRequest from '../../../core/data/dtos/claim.glass.request';
import VehicleClaimRequest from '../../../core/data/dtos/vehicleClaimRequest';


@Injectable()
export class ClaimService extends BaseCrudService<Claim> {
  controller = 'Claims';
  getMyClaims(idNumber: string) {
    this.controller = 'Claims';
    return this.get<Claim[]>({ idNumber });
  }

  rate(idNumber: string, rating: number) {
    return this.httpClient.post(`claims/${idNumber}/rate?rate=${rating}`, {});
  }

  createGlassClaim(claim: ClaimGlassRequest, claimReferenceNumber: string) {
    this.controller = 'cristalclaims';
    return this.create<ClaimGlassRequest, { eventNumber: string }>(
      claim,
      undefined,
      { claimReferenceNumber, claimSource: 0 },
      false,
    );
  }

  createVehicleClaim(claim: VehicleClaimRequest, claimReferenceNumber: string) {
    this.controller = 'vehicleclaims';
    return this.create<VehicleClaimRequest, string>(
      claim,
      undefined,
      { claimReferenceNumber:"", claimSource: 0 },
      false,
    );
  }
}
